import { ExclamationCircleFilled } from "@ant-design/icons";
import { message, Modal } from "antd";
import numeral from "numeral";
import { useCallback, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  cloudAddBank,
  cloudDeleteBank,
} from "store/bailiff/default/bank/default_bank.action";
import { defaultWalletAllSelector } from "store/bailiff/default/wallet/default_wallet.selector";
import { settingWithdrawAllSelector } from "store/bailiff/default/withdraw/setting_withdraw.selector";
import { setFinanceLifeOpenWithdraw } from "store/bailiff/finance/life/life.action";
import {
  cloudGenerateWithdraw,
  setPaymentWithdrawSearch,
} from "store/bailiff/payment/withdraw/payment_withdraw.action";
import {
  paymentWithdrawAllSelector,
  paymentWithdrawBanksSelector,
  paymentWithdrawSearchSelector,
} from "store/bailiff/payment/withdraw/payment_withdraw.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const { confirm } = Modal;

export const useWithdraw = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const setting = useSelector(settingWithdrawAllSelector);
  const wallet = useSelector(defaultWalletAllSelector);
  const min = setting?.min || 500000;
  const max = wallet?.earn - wallet?.lock;
  const labelMin = numeral(min).format("0,0");
  const labelMax = numeral(max).format("0,0");

  // -------------------------- FUNCTION ------------------------

  // mở modal withdraw
  const handleOpen = () => {
    dispatch(setFinanceLifeOpenWithdraw(true));
  };

  // đóng modal withdraw
  const handleClose = useCallback(
    (form) => {
      dispatch(setFinanceLifeOpenWithdraw(false));
      form?.resetFields();
    },
    [dispatch],
  );

  // thực thi rút tiền.
  const handleWithdraw = (form) => {
    form
      ?.validateFields()
      .then((values) => {
        // Handle the withdraw logic here
        if (!values) return message.error("Dữ liệu không hợp lệ");
        const amount = values?.amount;
        if (amount < setting?.min)
          return message.error(`Số tiền rút tối thiểu là ${labelMin}đ`);
        if (amount > max)
          return message.error(`Số tiền rút tối đa là ${labelMax}đ`);
        // After processing, close the modal
        setLoading(true);
        const code = values?.code;
        const accountNumber = values?.accountNumber;
        const accountName = values?.accountName;
        const saveBank = values?.saveBank || false;
        const source = "supporter";
        console.log({
          code,
          accountName,
          accountNumber,
          amount,
          source,
          saveBank,
        });
        dispatch(
          cloudGenerateWithdraw(
            { amount, source, accountNumber, code, accountName },
            (res) => {
              setLoading(false);
              if (res?.status === 200) {
                message.success("Đã tạo đơn rút tiền thành công");
                handleClose(form);
                handleAddBank({
                  accountName,
                  accountNumber,
                  code,
                  saveBank,
                  form,
                });
              }
              if (res?.status === 500) {
                message.error(res?.data);
              }
            },
          ),
        );
      })
      .catch((err) => {
        setLoading(false);
        console.log({ err });
      });
  };

  // thêm tài khoản ngân hàng
  const handleAddBank = useCallback(
    ({ accountName, accountNumber, code, saveBank }) => {
      if (!saveBank) return;
      dispatch(
        cloudAddBank({ accountName, accountNumber, code }, (res) => {
          if (res?.status === 500) {
            message.error(res?.data);
          }
        }),
      );
    },
    [dispatch],
  );

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { loading, handleOpen, handleClose, handleWithdraw };
};

// use open banks.
export const useBanks = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleOpen = (form) => {
    form?.setFieldValue("openBank", true);
  };

  const handleCancel = (form) => {
    form?.setFieldValue("openBank", false);
  };

  const handleSearch = (value) => {
    dispatch(setPaymentWithdrawSearch(value));
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { handleOpen, handleCancel, handleSearch };
};

// use open account.
export const useAccounts = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleOpen = (form) => {
    form?.setFieldValue("openAccount", true);
  };

  const handleCancel = (form) => {
    form?.setFieldValue("openAccount", false);
  };

  const handleSelect = (form, data) => {
    const { accountName, accountNumber, code } = data;
    form?.setFieldValue("accountName", accountName);
    form?.setFieldValue("accountNumber", accountNumber);
    form?.setFieldValue("code", code);
    form?.setFieldValue("saveBank", false);
    handleCancel(form);
  };

  // show confirm delete account
  const showConfirmDeleteAccount = (id) => {
    confirm({
      title: "Bạn có chắc chắn muốn xoá tài khoản này khỏi danh bạ?",
      icon: <ExclamationCircleFilled />,
      content:
        "Thao tác này không thể phục hồi, hãy xác nhận bằng nút bên dưới.",
      centered: true,
      onOk() {
        handleRemoveBank(id);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleRemoveBank = (id) => {
    setLoading(true);
    dispatch(
      cloudDeleteBank({ id }, (res) => {
        setLoading(false);
        if (res?.status === 200) {
          message.success("Đã xóa tài khoản ngân hàng thành công");
        }
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return {
    loading,
    handleOpen,
    handleCancel,
    handleSelect,
    handleRemoveBank,
    showConfirmDeleteAccount,
  };
};

// withdraw lists.
export const useWithdrawLists = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const data = useSelector(paymentWithdrawAllSelector);

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { data };
};

//
export const useOptionsBanks = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const banks = useSelector(paymentWithdrawBanksSelector);
  const search = useSelector(paymentWithdrawSearchSelector);
  const data = refineData(banks, search);

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { banks, data };
};

const refineData = (data, search) => {
  let result = data || [];

  if (search !== "") {
    result = result.filter((item) => {
      const key = item?.shortName + " | " + item?.name;
      const lowerKey = key?.toLowerCase();
      const lowerSearch = search?.toLowerCase();
      return lowerKey?.includes(lowerSearch);
    });
  }

  return result;
};
